import styled, { css } from 'styled-components';

export const Container = styled.div`
  height: 100%;
  width: 64px;

  padding: 16px 8px;

  background-color: ${({ theme }) => theme.colors.blacks.ipBlack1};

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  box-sizing: border-box;
`;

export const IconContainer = styled.div`
  width: 48px;
  height: 48px;

  border-bottom: 1px solid ${({ theme }) => theme.colors.blacks.ipBlack4};
`;

export const InpulseIcon = styled.img`
  width: 32px;
  height: 32px;
`;

export const ModulesContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

interface ModuleIconProps {
  isSelected?: boolean;
}

export const ModuleIcon = styled.img<ModuleIconProps>`
  height: 16px;
  width: 16px;

  transition: filter 0.3s cubic-bezier(0, 0.64, 0.25, 0.99);

  ${({ isSelected }) =>
    !isSelected &&
    css`
      filter: brightness(0) invert(1);
    `}
`;

interface ModuleBoxProps {
  isSelected: boolean;
}

export const ModuleBox = styled.div<ModuleBoxProps>`
  width: 32px;
  height: 32px;

  display: flex;
  justify-content: center;
  align-items: center;
  transition:
    background-color 0.3s cubic-bezier(0, 0.64, 0.25, 0.99),
    border 0.3s cubic-bezier(0, 0.64, 0.25, 0.99);

  border-radius: 4px;

  cursor: pointer;

  ${({ isSelected, theme }) =>
    isSelected
      ? css`
          background-color: ${theme.colors.infoOrange};
          border-radius: 4px;
        `
      : css`
          &:hover > ${ModuleIcon} {
            filter: invert(70%) sepia(56%) saturate(331%) hue-rotate(340deg) brightness(100%)
              contrast(101%);
          }
        `}
`;

export const FooterContainer = styled.div`
  width: 100%;
  height: 48px;

  display: flex;
  justify-content: center;
  align-items: flex-end;

  border-top: 1px solid ${({ theme }) => theme.colors.blacks.ipBlack4};
`;
